import axios from 'axios';
import qs from 'qs';
import { navigate } from 'raviger';

import { errorClear } from './error';

import * as actionTypes from './actionTypes';

export let instance = null;

export const authenticationStart = () => {
    let base_url = process.env.REACT_APP_WEBAPI_BASE;

    if (process.env.REACT_APP_ENV === 'staging') {
        base_url = process.env.REACT_APP_WEBAPI_STAGING;
    } else if (process.env.REACT_APP_ENV === 'test') {
        base_url = process.env.REACT_APP_WEBAPI_TEST;
    } else if (process.env.REACT_APP_ENV === 'production') {
        base_url = process.env.REACT_APP_WEBAPI_PRODUCTION;
    }

    instance = axios.create({
        baseURL: base_url
    });

    return {
        type: actionTypes.AUTHENTICATION_START
    };
};

export const authenticationSuccess = (data) => {
    return {
        type: actionTypes.AUTHENTICATION_SUCCESS,
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        userName: data.userName,
        prevRoute: data.prevRoute,
        permissions: data.permissions,
        roles: data.roles
    };
};

export const authenticationFail = (error) => {
    return {
        type: actionTypes.AUTHENTICATION_FAIL,
        error: {
            status: (error.response && error.response.status) && error.response.status,
            message: (error.response && error.response.data && error.response.data.message) && error.response.data.message
        }
    };
};

export const authenticationClear = () => {
    return {
        type: actionTypes.AUTHENTICATION_LOGOUT,
    };
}

export const authenticationLogout = () => {
    return (dispatch) => {
        localStorage.clear();

        dispatch(errorClear());
        dispatch(authenticationClear());
        navigate('/');
    };
};

export const authenticationTimeout = (data) => {
    return (dispatch) => {
        setTimeout(() => {
            dispatch(authenticationLogout());
        }, data.expiresIn * 1000);
    };
};

export const authenticate = (options) => {
    return (dispatch) => {
        dispatch(authenticationStart());

        const payload = qs.stringify({
            grant_type: 'password',
            client_id: 'FM3',
            username: options.userName,
            password: options.password
        });

        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        };

        instance.post('/Token', payload, headers)
            .then((response) => {
                localStorage.setItem('authData', JSON.stringify({
                    accessToken: response.data.access_token,
                    refreshToken: response.data.refresh_token,
                    expireDate: response.data.expires,
                    userName: response.data.userName,
                    remember: options.remember
                }));
                dispatch(authenticationSuccess({ accessToken: response.data.access_token }));
                dispatch(authenticationTimeout({ expiresIn: response.data.expires_in }));
            })
            .catch((error) => {
                dispatch(authenticationFail(error));
            });
    }
};